module.exports = __webpack_public_path__ + "img/5.41e0bfe4.png";